import { render, staticRenderFns } from "./deleteRule.vue?vue&type=template&id=10ca65b9&scoped=true&"
import script from "./deleteRule.vue?vue&type=script&lang=js&"
export * from "./deleteRule.vue?vue&type=script&lang=js&"
import style0 from "./deleteRule.vue?vue&type=style&index=0&id=10ca65b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ca65b9",
  null
  
)

export default component.exports